// import node module libraries
import React, { useRef } from 'react';
import { Link } from 'react-router-dom';
import { Card } from 'react-bootstrap';
import { useReactToPrint } from 'react-to-print';

// import sub components
// import profile layout wrapper
import PrintInvoiceDetailsBulletinpaie from './PrintInvoiceDetailsBulletinpaie';
import BulletinpaieProfileLayout from './BulletinpaieProfileLayout';

const InvoiceDetailsBulletinpaie = () => {
	const componentRef = useRef();

	const handlePrint = useReactToPrint({
		content: () => componentRef.current
	});

	return (
		<BulletinpaieProfileLayout>
			<Card>
				<Link
					to="#"
					className="text-muted print-link no-print text-end me-5 mt-3 "
					onClick={handlePrint}
				>
					<i className="fa-solid fa-print"></i>
				</Link>
				<PrintInvoiceDetailsBulletinpaie ref={componentRef} />
			</Card>
		</BulletinpaieProfileLayout>
	);
};

export default InvoiceDetailsBulletinpaie;
